import * as React from "react";
const SvgIcon22 = props => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 22 22" {...props}><defs><linearGradient id="icon_22_svg__a" x1={0.5} x2={0.5} y2={1} gradientUnits="objectBoundingBox"><stop offset={0} stopColor="currentColor" /><stop offset={1} stopColor="currentColor" /></linearGradient></defs><g transform="translate(-.608 -.458)"><circle cx={11} cy={11} r={11} transform="rotate(-90 11.533 10.925)" style={{
      fill: "url(#icon_22_svg__a)",
      opacity: 0.15
    }} /><text data-name="\uFF1F" transform="translate(8.108 16.958)" style={{
      fill: "currentColor",
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "&quot"
    }}><tspan x={0} y={0}>{"\uFF1F"}</tspan></text></g></svg>;
export default SvgIcon22;